'use client';

import dynamic from 'next/dynamic';

import useWindowDimensions from '@/hooks/use-window-dimensions';

import Spinner from '@/components/Spinner';

// ClientOnlySnippets *can't* run during SSR, we get an error. Lazy-load it, omitting it during SSR.
const ClientOnlySnippet = dynamic(
  () => import('@/components/CodeSnippet/ClientOnlySnippet'),
  {
    ssr: false,
    loading: () => <Spinner style={{ alignSelf: 'center' }} />,
  }
);

function LCHColorSnippet({ hue, chroma, lightness }) {
  const windowDimensions = useWindowDimensions();

  const hslSnippet = `lch(${lightness}% ${chroma} ${hue})`;

  const isDesktop =
    typeof windowDimensions.width === 'number' &&
    windowDimensions.width > 690;

  // Indent the code differently on smaller screens, so that it fits.
  const code = isDesktop
    ? `.box {
  background-color: ${hslSnippet};
}`
    : `.box {
  background-color:
    ${hslSnippet};
}`;

  return <ClientOnlySnippet omitCopyButton code={code} lang="css" />;
}

export default LCHColorSnippet;
